const mask = (value: String | undefined) => {
  if (!value) return '';

  return value.replace(/[\D]/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
}

const unMask = (value: String) => {
  if (!value) {
    return "";
  }

  return value.replace(/\D/g, '');
}

export default {
  mask,
  unMask
}
